import React from 'react';
import { Table } from 'antd';
import { moneyAddComma } from '../../utils';

const TableDOM = props => {
    let {
        current = 1,
        total = 0,
        totalMny = 0,
        historyBillMoney = 0,
        vacantBillMoney = 0,
        receivedMoney = 0,
        totalDiscountMny = 0,
        uncollectedMoney = 0,
        vacantMoney= 0,
        columns = [],
        data = [],
        loading = false,
        onChange,
        pagination,
        rowSelection,
        scroll,
        onRow,
        hint,
    } = props;

    return (
        <Table
            loading={loading}
            pagination={
                pagination === false
                    ? false
                    : {
                        current, total, showTotal: (total) => {
                            return (
                              <span><span style={{ color: 'red' }}>{hint}</span>共<b>{total}</b>条记录{totalMny ? <span>，<b>{moneyAddComma(totalMny)}</b>元</span> : null}{totalDiscountMny ? <span>，优惠：<b>{moneyAddComma(totalDiscountMny)}</b>元</span> : null}{receivedMoney ? <span>，已收：<b>{moneyAddComma(receivedMoney)}</b>元</span> : null}{uncollectedMoney ? <span>，待收：<b>{moneyAddComma(uncollectedMoney)}</b>元</span> : null}{historyBillMoney ? <span>，历史迁移：<b>{moneyAddComma(historyBillMoney)}</b>元</span> : null}{vacantBillMoney ? <span>，空置账单金额：<b>{moneyAddComma(vacantBillMoney)}</b>元</span> : null}</span>
                            )
                        }
                    }
            }
            columns={columns}
            dataSource={data}
            rowKey={(record, index) => index}
            onChange={pagination => onChange({ current: pagination.current })}
            rowSelection={rowSelection}
            scroll={scroll}
            onRow={onRow}
        />
    )
};

export default TableDOM;


// WEBPACK FOOTER //
// ./src/components/Table/index.js